import Dropdown from '../../atoms/Dropdown.js';
import QuantityInput from '../../atoms/QuantityInput.js';

/**
 * @typedef {{}} TravalersProps
 */

/**
 * Travalers component.
 * @augments {Base<TravalersProps>}
 */
export default class Travelers extends Dropdown {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Travelers',
    refs: ['dropdown', 'btn', 'placeholder', 'close[]'],
    emits: ['submit'],
    components: {
      QuantityInput,
    },
  };

  /**
   *
   */
  mounted() {
    this.defaultPlaceholder = this.$refs.placeholder.innerHTML;

    setTimeout(() => {
      this.changePlaceholder();
    }, 0);
  }

  /**
   *
   */
  onQuantityInputChange() {
    this.changePlaceholder();
  }

  /**
   *
   */
  changePlaceholder() {
    this.$refs.placeholder.innerHTML = '';
    let placeholderString = '';
    let totalTravelers = 0;

    this.$children.QuantityInput.forEach((element) => {
      if (element.inputValue > 0) {
        totalTravelers += element.inputValue;
      }
    });

    placeholderString =
      totalTravelers > 0 ? `${totalTravelers} voyageur(s)` : this.defaultPlaceholder;
    this.$refs.placeholder.innerHTML = placeholderString;
  }

  /**
   *
   */
  open() {
    this.$parent.open();
    super.open();
  }

  /**
   *
   */
  close() {
    if (this.isOpen) {
      this.$emit('submit');
    }
    super.close();
  }
}
